import configuration from "@/utils/Config";
import { restDetailsHandler } from "@/utils/rest/RestClient";
import { createEffect } from "effector";
import { AttestationDto } from "@state/document/dto/request/AttestationDto";

const baseUrl = configuration.backendBaseUrl;
const attestationUrl = baseUrl + "/attestation";

export const requestGetAttestation = createEffect({
  handler: restDetailsHandler<Blob, AttestationDto>(
    attestationUrl,
    undefined,
    undefined,
    "application/pdf",
  ),
});
